module.exports = __webpack_public_path__ + "static/media/group_edit.4ce80ab7.svg";